<template>
    <div class="modal fade" id="modalShow" role="dialog" aria-labelledby="staticBackdropLabel" aria-hidden="true"
         style="position: fixed;" >
        <button type="button" class="closeX" id="closeModal" data-dismiss="modal" aria-label="Close" hidden></button>
        <div class="modal-dialog modal-sm lot-show-dialog" role="document">
            <div class="modal-content lot-show-content" >
                <div class="modal-body lot-show-body" v-if="lotsIndex.status">
                    <div class="lot-show-card">
                        <div class="lot-show-card__header">
                            <div class="lot-show-card__top">
                                <span class="lot-show-card__eyebrow">{{ t(modalTitle) }}</span>
                                <div class="lot-show-card__actions">
                                    <a id="task-actions" aria-haspopup="true" data-toggle="dropdown" class="lot-show-more"
                                       v-if="hasUpdatePermission || hasDeletePermission || this.$hasPermission('Lot_show', true)">
                                        <i class="icon-dehaze"/>
                                    </a>
                                    <div aria-labelledby="task-actions" class="dropdown-menu dropdown-menu-right lot-show-dropdown"
                                         id="dropdownMenu">
                                        <p v-if="this.$hasPermission('Lot_show', true)" type="button" data-toggle="modal"
                                           @click="$emit('view', lot?.lot?.id)"
                                           data-target="#customModalTwo" class="pointer lot-show-dropdown__item">
                                            <i class="icon-eye dropdown-iten-padding"></i> {{ t('GENERAL.MORE_INFO') }}
                                        </p>
                                        <p v-if="hasUpdatePermission" data-toggle="modal"
                                           @click="$emit('update', lot?.lot?.id)"
                                           data-target="#customModalTwo" class="pointer lot-show-dropdown__item">
                                            <i class="icon-mode_edit dropdown-iten-padding"></i> {{ t('ACTIONS.EDIT') }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="lot-show-status dynamic-background-card dynamic-text-color"
                                 :style="{'--dynamic-bg': status.backgroud_collor, '--dynamic-color': status.text_collor}">
                                <h3 class="dynamic-text-color" :style="{'--dynamic-color': status.text_collor}">{{ lot.name }}</h3>
                                <span class="dynamic-text-color" :style="{'--dynamic-color': status.text_collor}">{{ status.name }}</span>
                            </div>
                        </div>

                        <div class="lot-show-price">
                            <small>{{ t('PROPERTIES.PRICE') }}</small>
                            <strong>{{ toCurrency(lot.price) }}</strong>
                        </div>

                        <div class="lot-show-metrics">
                            <div class="lot-show-metric">
                                <small>{{ t('LOTS.BLOCK') }}</small>
                                <strong>{{ lot.block }}</strong>
                            </div>
                            <div class="lot-show-metric">
                                <small>{{ t('LOTS.TOTAL_AREA') }}</small>
                                <strong>{{ lot.total_area }}m²</strong>
                            </div>
                        </div>

                        <div class="lot-show-footer" :style="{'justify-content': formartButtons()}">
                            <button data-cy="lot_show_reserve" v-if="hasReservePermission && status.type === 0"
                                    type="button"
                                    data-toggle="modal"
                                    class="btn lot-show-btn lot-show-btn--primary"
                                    @click="$emit('reserve', lot)" data-target="#customModalTwo">
                                {{ t('LOTS.RESERVE') }}
                            </button>
                            <button v-if="lot.price && lot.price > 0 && (status.type === 1 || status.type === 0)"
                                    type="button" data-toggle="modal"
                                    class="btn lot-show-btn lot-show-btn--secondary"
                                    @click="$emit('simulate', lot, (canProposeSale && status.type === 1) ? 'propose' : 'simulate')"
                                    data-target="#customModalTwo">
                                {{ (canProposeSale && status.type === 1) ? `${t('LOTS.CREATE_PROPOSE')}/${t('GENERAL.SALE')}/${t('GENERAL.SIMULATOR')}` : t('GENERAL.SIMULATOR')}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {useI18n} from 'vue-i18n';
import Permission from '@/components/permission.vue';

export default {
    name: 'showLot',
    mixins: [Permission],
    emits: ['simulate', 'reserve', 'view', 'update'],
    props: {
        lotsIndex: {
            type: Object,
            required: true,
        },
        modalTitle: {
            type: String,
            required: true,
        },
    },
    setup() {
        const {t} = useI18n();
        return {t};
    },
    data() {
        return {
            lot: {},
            status: {},
            canProposeSimulate: false,
            hasDeletePermission: false,
            hasUpdatePermission: false,
            hasReservePermission: null,
        };
    },
    mounted() {
        this.lot = this.lotsIndex;
        if (this.lot.status){
            this.status = this.lotsIndex.status;
            this.permissonByStatus(this.status);
            this.checkIfCanSimulatePropose();
            this.hasReservePermission = this.$hasPermission('Reserve_create', true) && this.lotsIndex.status.type == 0;
        }
    },
    computed: {
        canProposeSale() {
            return this.lot.status.type === 1;
        }
    },
    watch: {
        lotsIndex: function () {
            this.updateModalInfs();
        },
    },
    methods: {
        updateModalInfs() {
            this.lot = this.lotsIndex;
            this.status = this.lotsIndex.status;
            this.permissonByStatus(this.status);
            this.hasReservePermission = this.$hasPermission('Reserve_create', true) && this.lotsIndex.status.type == 0;
        },
        permissonByStatus(status) {
            this.hasDeletePermission = (status.type == 0 || status.type == 4) ? this.$hasPermission('Lot_delete', true) : false;
            this.hasUpdatePermission = (status.type == 0 || status.type == 4 || status.type == 3 || ((status.type == 2) && Number(this.lot?.allotments?.id_configuracao_bd) < 0)) ? this.$hasPermission('Lot_update', true) : false;
        },
        toCurrency(value) {
            if (value === null) return 'Indisponível';
            return Intl.NumberFormat('pt-br', {style: 'currency', currency: 'BRL'}).format(value);
        },
        formartButtons() {
            return !this.hasReservePermission ? 'end !important' : 'space-between !important';
        },
    },
};
</script>

<style>
.lot-show-dialog {
    max-width: 360px;
}

.lot-show-content {
    background: transparent;
    border: 0;
    box-shadow: none;
}

.lot-show-body {
    padding: 0;
}

.lot-show-card {
    background:
        radial-gradient(ellipse at 0% 0%, rgba(14, 94, 78, 0.10), rgba(14, 94, 78, 0.035) 26%, transparent 60%),
        linear-gradient(135deg, #ffffff 0%, #fbfcfd 62%, #f7f9fb 100%);
    border: 1px solid #dce3ea;
    border-radius: 18px;
    box-shadow: 0 18px 44px rgba(15, 23, 42, 0.16);
    overflow: hidden;
    padding: 1rem;
    position: relative;
}

.lot-show-more {
    align-items: center;
    background: rgba(255, 255, 255, 0.88);
    border: 1px solid rgba(14, 94, 78, 0.12);
    border-radius: 999px;
    color: #0e5e4e;
    display: inline-flex;
    height: 34px;
    justify-content: center;
    text-decoration: none;
    width: 34px;
}

.lot-show-more:hover {
    background: #e7f4f0;
    color: #0e5e4e;
    text-decoration: none;
}

.lot-show-card__top {
    align-items: center;
    display: flex;
    gap: 0.75rem;
    justify-content: space-between;
    margin-bottom: 0.65rem;
}

.lot-show-card__actions {
    flex: 0 0 auto;
    position: static;
    z-index: 3;
}

.lot-show-card__header {
    text-align: left;
}

.lot-show-card__eyebrow {
    color: #0e5e4e;
    display: block;
    font-size: 0.7rem;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.lot-show-status {
    border-radius: 16px;
    min-height: 104px;
    padding: 1rem;
    text-align: center;
}

.lot-show-status h3 {
    font-size: 2rem;
    font-weight: 900;
    line-height: 1;
    margin-bottom: 0.35rem;
}

.lot-show-status span {
    font-size: 0.86rem;
    font-weight: 800;
    letter-spacing: 0.04em;
    text-transform: uppercase;
}

.lot-show-price {
    background: #f6faf9;
    border: 1px solid #e3ece9;
    border-radius: 14px;
    margin-top: 0.85rem;
    padding: 0.85rem;
    text-align: left;
}

.lot-show-price small,
.lot-show-metric small {
    color: #6d7f7b;
    display: block;
    font-size: 0.66rem;
    font-weight: 800;
    letter-spacing: 0.06em;
    margin-bottom: 0.2rem;
    text-transform: uppercase;
}

.lot-show-price strong {
    color: #173b34;
    display: block;
    font-size: 1.35rem;
    font-weight: 900;
    line-height: 1.2;
}

.lot-show-metrics {
    display: grid;
    gap: 0.65rem;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    margin-top: 0.65rem;
}

.lot-show-metric {
    background: #f6faf9;
    border: 1px solid #e3ece9;
    border-radius: 14px;
    padding: 0.75rem;
    text-align: left;
}

.lot-show-metric strong {
    color: #173b34;
    display: block;
    font-size: 1rem;
    font-weight: 900;
    line-height: 1.2;
}

.lot-show-footer {
    align-items: center;
    background: rgba(246, 250, 249, 0.86);
    border-top: 1px solid #e3ece9;
    display: flex;
    flex-wrap: wrap;
    gap: 0.55rem;
    margin: 1rem -1rem -1rem;
    padding: 0.85rem 1rem;
}

.lot-show-btn {
    border-radius: 999px;
    font-size: 0.78rem;
    font-weight: 800;
    margin: 0 !important;
    min-height: 38px;
    padding: 0.52rem 0.95rem;
}

.lot-show-btn--primary {
    background: linear-gradient(135deg, #0e5e4e, #0b7a5f);
    border: 0;
    box-shadow: 0 10px 22px rgba(14, 94, 78, 0.20);
    color: #ffffff;
}

.lot-show-btn--primary:hover {
    color: #ffffff;
    filter: brightness(1.04);
}

.lot-show-btn--secondary {
    background: #ffffff;
    border: 1px solid #b7ddd3;
    color: #0e5e4e;
}

.lot-show-btn--secondary:hover {
    background: #e7f4f0;
    color: #0e5e4e;
}

.lot-show-dropdown {
    background: #262b31;
    border: 0;
    border-radius: 10px;
    box-shadow: 0 16px 32px rgba(15, 23, 42, 0.22);
    color: white;
    left: auto !important;
    min-width: 160px;
    overflow: hidden;
    padding: 0.35rem;
    position: absolute !important;
    right: 0 !important;
    top: 2.65rem !important;
    transform: none !important;
    z-index: 1060;
}

.lot-show-dropdown:before {
    border-bottom: 10px solid #262b31 !important;
}

.lot-show-dropdown__item {
    align-items: center;
    border-radius: 8px;
    color: #ffffff;
    display: flex;
    font-size: 0.82rem;
    font-weight: 700;
    gap: 0.1rem;
    margin-bottom: 0;
    padding: 0.55rem 0.45rem;
}

.lot-show-dropdown__item:hover {
    background: rgba(255, 255, 255, 0.08);
}

.pointer {
    cursor: pointer;
}

.dropdown-iten-padding {
    padding-left: 0.8rem;
    padding-right: 0.2rem;
}

html.dark-theme .lot-show-card {
    background:
        linear-gradient(135deg, rgba(17, 24, 39, 0.98) 0%, rgba(23, 32, 51, 0.96) 100%) !important;
    border-color: transparent !important;
    box-shadow: none !important;
}

html.dark-theme .lot-show-content {
    background: transparent !important;
    border: 0 !important;
    box-shadow: none !important;
}

html.dark-theme .lot-show-more,
html.dark-theme .lot-show-price,
html.dark-theme .lot-show-metric,
html.dark-theme .lot-show-footer {
    background: rgba(15, 23, 42, 0.28) !important;
    border-color: rgba(94, 234, 212, 0.14) !important;
}

html.dark-theme .lot-show-card__eyebrow,
html.dark-theme .lot-show-more,
html.dark-theme .lot-show-btn--secondary {
    color: var(--dark-primary) !important;
}

html.dark-theme .lot-show-price small,
html.dark-theme .lot-show-metric small {
    color: var(--dark-text-muted) !important;
}

html.dark-theme .lot-show-price strong,
html.dark-theme .lot-show-metric strong {
    color: var(--dark-text) !important;
}

html.dark-theme .lot-show-btn--secondary {
    background: rgba(20, 184, 166, 0.08) !important;
    border-color: rgba(94, 234, 212, 0.20) !important;
}

@media (max-width: 575px) {
    .lot-show-dialog {
        margin-left: auto;
        margin-right: auto;
        max-width: calc(100vw - 1.25rem);
    }

    .lot-show-metrics {
        grid-template-columns: 1fr;
    }

    .lot-show-footer {
        flex-direction: column;
    }

    .lot-show-btn {
        width: 100%;
    }
}
</style>
